<template>
  <div id="membersContainer" class="page-container">
    <div class="page-content">
      <!-- <div v-if="showWarningEmptyTeam" class="warning-popup" style="height: 0">
        <div class="body flex-center" style="width: 490px">
          <div class="fs-500 fc-FFFFFF fs-14">
            You have {{emptyMember.length}} teams with no members
          </div>
          <div
            @click="ignoreWarning"
            class="cursor-pointer ml-auto undo-bottom flex-mid mr-8"
          >
            Ignore
          </div>
          <div @click="confirmEmptyTeam" class="cursor-pointer delete-bottom flex-mid">
            Delete empty teams
          </div>
        </div>
      </div> -->
      <div class="flex-center mt-16">
        <div class="flex-row-center" style="height: 52px">
          <img src="../assets/images/navbar/ic_members.webp" class="icon-pages" />
          <span class="page-title">{{ $t("page.members") }}</span>
          <span class="page-des page-des-line-button">{{
            $t("page.members_description")
          }}</span>
        </div>
        <div
          v-if="
            !loadingOrgChartView &&
            orgChartView &&
            orgChartView.orgChartArr.length > 0
          "
          @click="orgChartModal()"
          class="org-chart-btn flex-mid ml-auto cursor-pointer"
          :title="$t('members.ORGANIZATION_CHART_VIEW')"
        >
          <happily-icon name="network" :size="22" />
        </div>
      </div>
      <el-tabs
        class="style-bar"
        v-model="activeName"
        @tab-click="forceRerender"
      >
        <el-tab-pane label="Members" :name="anchor.members" default>
          <span slot="label" class="title-bar">{{ $t("page.members") }}</span>
          <member></member>
        </el-tab-pane>
        <el-tab-pane label="Teams" :name="anchor.teams">
          <span slot="label" class="title-bar">{{ $t("page.teams") }}</span>
          <teams
            v-if="renderComponent == false && activeName == 'teams'"
          ></teams>
        </el-tab-pane>
        <el-tab-pane label="Managers" :name="anchor.managers">
          <span slot="label" class="title-bar">{{ $t("page.managers") }}</span>
          <managers
            v-if="renderComponent == false && activeName == 'managers'"
          ></managers>
        </el-tab-pane>
        <el-tab-pane label="Cohorts" :name="anchor.cohorts">
          <span slot="label" class="title-bar">{{ $t("page.cohorts") }}</span>
          <cohorts
            v-if="renderComponent == false && activeName == 'cohorts'"
          ></cohorts>
        </el-tab-pane>
        <!-- <el-tab-pane label="Relationships" :name="anchor.relationships">
          <span slot="label" class="title-bar">Relationships</span>
          <relationships
            v-if="renderComponent == false && activeName == 'relationships'"
          ></relationships>
        </el-tab-pane> -->
      </el-tabs>
      <component
        v-if="
          (activeName == 'teams' || activeName == 'managers') && renderComponent
        "
        v-bind:is="activeName"
      ></component>
      <el-dialog
        :visible.sync="orgCharDialog"
        :before-close="orgCharClose"
        width="86%"
        top="5vh"
        class="remove-padding-modal"
      >
        <div
          class="p-40"
          style="padding-bottom: 24px; box-shadow: 0px 6px 6px #00000014"
        >
          <div class="fs-20 fw-700 fc-000000">
            {{ $t("members.ORGANIZATION_CHART_VIEW") }}
          </div>
          <div class="flex mt-16">
            <el-autocomplete
              style="width: 240px"
              popper-class="my-autocomplete"
              v-model="orgChartSearch"
              :fetch-suggestions="querySearch"
              :placeholder="$t('members.search_by_name_or_team')"
              @select="handleSelectMember"
            >
              <template slot-scope="{ item }">
                <div class="value" 
                :class="[`${item.teamName ? '' : 'py-8'}`,
                  blurMode ? 'blurelement':''
                ]">
                  {{ item.value }}
                </div>
                <span class="link"
                :class="[ blurMode ?  'blurelement': '' ]">{{ item.teamName }}</span>
              </template>
            </el-autocomplete>
            <el-tooltip placement="top" :disabled="!disableButton">
              <div slot="content">
                {{ $t("members.the_org_chart") }}
              </div>
              <div
                @click="downLoadChart()"
                :class="`flex-mid ml-auto ${
                  disableButton ? 'opa-04' : 'cursor-pointer'
                }`"
              >
                <img class="mr-12" :src="$utils('icons', 'ic_xls_download')" />
                <div class="fc-000000 fs-15 fw-700 opa-07">
                  {{ $t("global.DOWNLOAD") }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div style="width: 100%" class="org-chart-height">
          <div
            v-dragscroll
            style="width: 100%; overflow: auto"
            class="thin-scrollbar grab-bing org-chart-height"
          >
            <div
              class="py-32 px-20"
              :style="`width: ${orgChartConfig.width + 36}px`"
            >
              <div></div>
              <div class="big-boss flex">
                <div
                  class="org-container py-20"
                  ref="printOrgChart"
                  @click="disableDownloadButton(1)"
                >
                  <div
                    :id="'orgChart_' + orgChartData.id"
                    class="org-card"
                    :style="`border-left-color: ${orgChartData.teamColor}; margin: auto;`"
                  >
                    <div class="info-box flex-center">
                      <img
                        v-if="orgChartData.pic"
                        v-lazy="orgChartData.pic"
                        :alt="
                          orgChartData.firstname + ' ' + orgChartData.lastName
                        "
                        :key="orgChartData.pic"
                        class="image-skeleton image-profile-38 flex-mid mr-12"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      />
                      <div v-else class="image image-profile-38 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <div class="text-in-image text-in-image-38 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: orgChartData.firstname,
                              lastName: orgChartData.lastname,
                            })
                          }}
                        </div>
                      </div>
                      <div class="flex-column card-description">
                        <span class="fs-13 fw-700 ellipsis"
                        :class="[ blurMode ?  'blurelement': '' ]"
                          >{{ orgChartData.firstname }}
                          {{ orgChartData.lastname }}</span
                        >
                        <span class="fs-13 opa-06 ellipsis"
                        :class="[ blurMode ?  'blurelement': '' ]">{{
                          orgChartData.teamName
                        }}</span>
                      </div>
                    </div>
                    <div class="footer-box flex-center">
                      <div class="div-active">
                        <div
                          class="btn-status"
                          :class="`status-${orgChartData.status}`"
                        >
                          {{ orgChartData.status }}
                        </div>
                      </div>
                      <div class="ml-auto fs-11 fw-700">{{ $t("insights.Impact_Rating") }}</div>
                      <div
                        :class="`ml-8 impact-tag impact-tag-${
                          orgChartData.impact_rating < 40
                            ? 'red'
                            : orgChartData.impact_rating < 70
                            ? 'yellow'
                            : 'green'
                        }`"
                      >
                        {{
                          orgChartData.impact_rating
                            ? orgChartData.impact_rating.toFixed(1)
                            : orgChartData.impact_rating
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="child-chart-container">
                    <input
                      type="checkbox"
                      checked="checked"
                      :id="'input_' + orgChartData.id"
                      class="checkmark checkbox"
                      :style="`background-color: ${orgChartData.teamColor};`"
                    />
                    <span
                      class="checkmark line flex-mid"
                      :style="`background-color: ${orgChartData.teamColor};`"
                    >
                      <div class="width-line"></div>
                    </span>
                    <span
                      class="checkmark number flex-mid"
                      :style="`background-color: ${orgChartData.teamColor};`"
                      >{{ orgChartData.directReport }}</span
                    >
                    <div class="child-chart">
                      <div class="flex-mid">
                        <div
                          class="opa-01"
                          style="
                            width: 2px;
                            height: 43px;
                            background-color: #000;
                          "
                        ></div>
                      </div>
                      <div v-html="orgChartConfig.HTML"></div>
                    </div>
                  </div>
                  <div
                    v-for="item in NoBossData"
                    :key="item.id"
                    class="px-20"
                    :style="`width: ${orgChartConfig.width + 36}px`"
                  >
                    <div></div>
                    <div class="big-boss flex">
                      <div class="org-container py-20">
                        <div
                          :id="'orgChart_' + item.id"
                          class="org-card"
                          :style="`border-left-color: ${item.teamColor}; margin: auto;`"
                        >
                          <div class="info-box flex-center">
                            <img
                              v-if="item.pic"
                              v-lazy="item.pic"
                              :alt="item.firstname + ' ' + item.lastName"
                              :key="item.pic"
                              class="
                                image-skeleton image-profile-38
                                flex-mid
                                mr-12
                              "
                              :class="[ blurMode ?  'blurelement': '' ]"
                            />
                            <div
                              v-else
                              class="image image-profile-38 flex-mid mr-12"
                              :class="[ blurMode ?  'blurelement': '' ]"
                            >
                              <div
                                class="text-in-image text-in-image-38 flex-mid"
                              >
                                {{
                                  $utils("acronymName", {
                                    firstName: item.firstname,
                                    lastName: item.lastname,
                                  })
                                }}
                              </div>
                            </div>
                            <div class="flex-column card-description"></div>
                            <span class="fs-13 fw-700 ellipsis"
                            :class="[ blurMode ?  'blurelement': '' ]"
                              >{{ item.firstname }} {{ item.lastname }}</span
                            >
                            <span class="fs-13 opa-06 ellipsis"
                            :class="[ blurMode ?  'blurelement': '' ]">{{
                              item.teamName
                            }}</span>
                          </div>
                          <div class="footer-box flex-center">
                            <div class="div-active">
                              <div
                                class="btn-status"
                                :class="[`status-${item.status}`]"
                              >
                                {{ item.status }}
                              </div>
                            </div>
                            <div class="ml-auto fs-11 fw-700">
                              {{ $t("insights.Impact_Rating") }}
                            </div>
                            <div
                              :class="`ml-8 impact-tag impact-tag-${
                                item.impact_rating < 40
                                  ? 'red'
                                  : item.impact_rating < 70
                                  ? 'yellow'
                                  : 'green'
                              }`"
                            >
                              {{ item.impact_rating.toFixed(1) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <download-progress
          :active="generateImage"
          :wording="$t('members.preparing_org_chart_download')"
        ></download-progress>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";
import format from 'date-fns/format'
export default {
  directives: {
    dragscroll,
  },
  name: "members",
  components: {
    member: require("./members/members").default,
    teams: require("./members/teams").default,
    managers: require("./members/managers").default,
    cohorts: require("./members/cohorts").default,
    // relationships: require("./members/relationships").default,
    downloadProgress: require("./even/download-progress").default,
  },
   created(){
    this.$store.dispatch("newmember/getTeamAll",this.user);
    this.$store.dispatch("newmember/getRecognition", this.user).then(()=>{
      // this.$store.dispatch("newmember/getHerepoint", this.user);
    })
    //this.$root.$on('archivedModalClick', () => this.activeName = "members");
    //this.$root.$on('clickReviewUpdates', () => this.activeName = "members");
   
  },
  computed: {
    user() {
      const user = this.$store.getters["authen/user"];
      this.activeName = "members";
      return user;
    },
    orgChartView() {
      return this.$store.getters["newmember/orgChartView"];
    },
    loadingOrgChartView() {
      return this.$store.getters["newmember/loadingOrgChartView"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    // showWarningEmptyTeam() {
    //   const oldValue = localStorage.getItem("_ignore_empty_team");
    //   const newValue = this.emptyMember.length; // get This.
    //   const loadingTeam = false; // get This.
    //   if (this.ignoreBTN) {
    //     if (!loadingTeam && oldValue != newValue && newValue != 0) {
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    // emptyMember(){
    //   return this.$store.getters["newmember/emptyMember"];
    // }
  },
  data() {
    return {
      activeName: "members",
      anchor: {
        members: "members",
        teams: "teams",
        managers: "managers",
        cohorts: "cohorts",
        // relationships: "relationships",
      },
      ignoreBTN: 1,
      renderComponent: true,
      printOutput: null,
      orgCharDialog: false,
      orgChartData: [],
      orgChartSearch: "",
      orgChartOldSearch: [],
      memberData: [],
      NoBossData: [],
      orgChartConfig: {
        HTML: "",
        width: 996,
        widhtNode: 252,
      },
      generateImage: false,
      disableButton: true,
      rootChangeTabHandler: null,
      rootOrgChartModalHandler: null,
    };
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        this.forceRerender();
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "members", params: { tab } });
        }
      }
    },
  },
  mounted() {
    const paramsTab = this.$router.currentRoute.params.tab;
    if (this.$route.query.welcome == "true") {
      this.$router.push({
        name: "members",
        params: { tab: "members" },
        query: { welcome: "false" },
      });
    }
    if (paramsTab && this.anchor[paramsTab] && !this.$route.query.welcome) {
      this.activeName = paramsTab;
    } else {
      const tab = this.activeName || "";
      if (paramsTab != tab) {
        this.$router.push({ name: "members", params: { tab } });
      }
    }

    this.rootChangeTabHandler = (item) => {
      if (item.path == "members") {
        this.activeName = item.tab;
      }
    };
    this.rootOrgChartModalHandler = () => this.orgChartModal();

    this.$root.$on('changeTab', this.rootChangeTabHandler);
    this.$root.$on('orgChartModal', this.rootOrgChartModalHandler);
  },
  beforeDestroy() {
    if (this.rootChangeTabHandler) {
      this.$root.$off('changeTab', this.rootChangeTabHandler);
    }
    if (this.rootOrgChartModalHandler) {
      this.$root.$off('orgChartModal', this.rootOrgChartModalHandler);
    }
  },
  methods: {
    async disableDownloadButton(i) {
      const el = this.$refs.printOrgChart;
      if (el || i > 30) {
        const width = el.offsetWidth;
        // if (width < 9000) {
          this.disableButton = false;
        // } else {
        //   this.disableButton = true;
        // }
      } else {
        await this.$utils("waitingTime", 100);
        this.disableDownloadButton((i += 1));
      }
    },
    orgChartModal() {
      this.orgChartData = this.orgChartView.orgChart; // TODO: Add Real data for chart
      this.memberData = this.orgChartView.orgChartArr; // TODO: Add Mock data for searching
      this.NoBossData = this.orgChartView.orgChartNoBoss
        ? this.orgChartView.orgChartNoBoss.children
        : {};
      this.renderOrganizationChar();
      this.orgCharDialog = true;
      this.disableDownloadButton(1);
    },
    forceRerender() {
      if (
        (this.activeName == "teams" ||
          this.activeName == "managers" ||
          this.activeName == "cohorts" ||
          this.activeName == "relationships") &&
        this.renderComponent == true
      ) {
        this.renderComponent = false;
      }
    },
    handleSelectMember(item) {
      // ****** From Jing ******
      // DO NOT CODING LIKE ME! Do not use `document` in virtual DOM. orz
      let refUser = item.refId.length;
      this.clecrDataSerach();
      const searchId = "orgChart_" + item.id;
      const selectedElement = document.getElementById(searchId);
      if (selectedElement) {
        selectedElement.scrollIntoView({ inline: "center", block: "center" });
        if (item.teamMembers) {
          for (let i = 0; i < item.teamMembers.length; i++) {
            const orgChartCard = "orgChart_" + item.teamMembers[i];
            const elementFocus = document.getElementById(orgChartCard);
            elementFocus.classList.add("card-focus");
            this.orgChartOldSearch.push(orgChartCard);
          }
          refUser = refUser + 1;
        } else {
          selectedElement.classList.add("card-focus");
          this.orgChartOldSearch.push(searchId);
        }

        if (refUser > 1) {
          for (let i = 1; i < refUser; i++) {
            let refElement = document.getElementById(
              "input_" + item.refId[i - 1]
            );
            if (refElement) {
              refElement.checked = true;
            }
          }
        }
      }
    },
    querySearch(queryString, cb) {
      let data = this.memberData;
      let resultsValue = queryString
        ? data.filter(this.queryDataByValue(queryString))
        : data;
      let resultsTeam = queryString
        ? data.filter(this.queryDataByTeam(queryString))
        : [];
      cb([...new Set(resultsValue.concat(resultsTeam))]);
    },
    queryDataByValue(queryString) {
      return (data) => {
        return (
          data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    queryDataByTeam(queryString) {
      return (data) => {
        return (
          data.teamName.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    async downLoadChart() {
      const datenow = format(new Date(), 'DD-MM-YYYY');
      this.generateImage = true;
      const ele = document.getElementsByClassName("org-card");
      for (let i = 0; i < ele.length; i++) {
        ele[i].classList.add("border-for-export");
      }
      const el = this.$refs.printOrgChart;
      const elementToCapture = el 
      const canvas = document.createElement('canvas');
      canvas.width = elementToCapture.clientWidth;
      canvas.height = elementToCapture.clientHeight;
      let scale = 1
      if(canvas.width > 30000){
        scale = 0.7
      }
      // const desiredWidth = 800; // ความกว้างที่คุณต้องการ
      // const originalWidth = 29736; // ความกว้างขององค์ประกอบ HTML

      // const scale = desiredWidth / originalWidth;
      // ลดขนาดภาพลงครึ่งหนึ่ง
      // const scale = 0.5;
      
      // วาดรูปภาพจากองค์ประกอบ HTML ไปยัง Canvas
      await this.$html2canvas(elementToCapture, { canvas,scale });

      // แปลง Canvas เป็นรูปภาพ
      const image = canvas.toDataURL('image/png');

      // สร้างลิงก์สำหรับการดาวน์โหลด
      const downloadLink = document.createElement('a');
      downloadLink.href = image;
      downloadLink.download = `Organization Chart ${datenow}.png`;
      downloadLink.click();
      for (let i = 0; i < ele.length; i++) {
        ele[i].classList.remove("border-for-export");
      }
      this.generateImage = false;
      console.clear();
    },
    // async downLoadChart() {
    //   this.generateImage = true;
    //   const ele = document.getElementsByClassName("org-card");
    //   const el = this.$refs.printOrgChart;
    //   const width = el.offsetWidth;
    //   if (width < 9000) {
    //     await this.printImage(ele, el);
    //     const a = document.createElement("a");
    //     a.href = this.printOutput;
    //     a.download = "Organization Chart"; //File name Here
    //     a.click();
    //     document.location = this.printOutput;
    //     for (let i = 0; i < ele.length; i++) {
    //       ele[i].classList.remove("border-for-export");
    //     }
    //   }
    //   this.generateImage = false;
    //   console.clear();
    // },
    async printImage(ele, el) {
      for (let i = 0; i < ele.length; i++) {
        ele[i].classList.add("border-for-export");
      }
      const options = {
        type: "dataURL",
        allowTaint: false,
        useCORS: true,
        logging: false,
      };
      this.printOutput = await this.$html2canvas(el, options);
    },
    renderOrganizationChar() {
      let orgChartData = this.orgChartData;
      const widhtNode = this.orgChartConfig.widhtNode;
      let newChartWidht = widhtNode * orgChartData.widthOfNode;
      if (newChartWidht > this.orgChartConfig.width) {
        this.orgChartConfig.width = newChartWidht;
      }
      if (orgChartData.directReport > 0) {
        this.orgChartConfig.HTML = this.checkedChild(orgChartData);
      }
    },
    checkedChild(orgChartData) {
      let loopChild = "";
      let teamLeader = false;
      if (orgChartData.directReport > 0) {
        for (let i = 0; i < orgChartData.directReport; i++) {
          let data = this.loopChart(
            orgChartData.children[i],
            i + 1,
            orgChartData.directReport
          );
          loopChild = loopChild + data.html;
          if (!teamLeader) {
            teamLeader = data.leader;
          }
        }
      }
      if (teamLeader) {
        return `<div class="flex">${loopChild}</div>`;
      } else {
        return `<div>${loopChild.split("tree-line").join("")}</div>`;
      }
    },
    loopChart(item, nowChild, maxChild) {
      let orgCard = "";
      let threeLine = "line";
      let teamLeader = false;
      let picProfile = `
        <div v-else class="image image-profile-38 flex-mid mr-12">
          <div class="text-in-image text-in-image-38 flex-mid">
            ${this.$utils("acronymName", {
              firstName: item.firstname,
              lastName: item.lastname,
            })}
          </div>
        </div>`;
      if (maxChild === 1) {
        threeLine = "";
      } else if (nowChild === 1) {
        threeLine = "line first";
      } else if (nowChild === maxChild) {
        threeLine = "line last";
      }
      if (item.pic) {
        picProfile = `
        <img
          src="${item.pic}"
          :alt="${item.firstname} + ' ' + ${item.lastName}"
          class="image-skeleton image-profile-38 flex-mid mr-12"
        />`;
      }
      let blurClass = "";
      if ( this.blurMode ) {
        blurClass = "blurelement";
      }
      if (item.directReport > 0) {
        teamLeader = true;
        orgCard = `
          <div class="org-container">
            <div class="tree-line">
              <div class="${threeLine}"></div>
            </div>
            <div class="flex-mid mx-auto" style="width: 252px;">
              <div
                class="opa-01"
                style="
                  width: 2px;
                  height: 14px;
                  background-color: #000;
                "
              ></div>
            </div>
            <div
              id="orgChart_${item.id}"
              class="org-card"
              style="border-left-color: ${item.teamColor};"
            >
              <div class="info-box flex-center ${blurClass}">
                ${picProfile}
                <div class="flex-column card-description">
                  <span class="fs-13 fw-700 ellipsis">${item.firstname} ${
          item.lastname
        }</span>
                  <span class="fs-13 opa-06 ellipsis">${item.teamName}</span>
                </div>
              </div>
              <div class="footer-box flex-center">
                <div class="div-active">
                  <div class="btn-status status-${item.status}">
                    ${item.status}
                  </div>
                </div>
                <div class="ml-auto fs-11 fw-700">${this.$t("insights.Impact_Rating")}</div>
                <div
                  class="ml-8 impact-tag impact-tag-${
                    item.impact_rating < 40
                      ? "red"
                      : item.impact_rating < 70
                      ? "yellow"
                      : "green"
                  }"
                >
                  ${item.impact_rating.toFixed(1)}
                </div>
              </div>
            </div>
            <div class="child-chart-container">
              <input
                type="checkbox"
                checked="checked"
                id="input_${item.id}"
                class="checkmark checkbox"
                style="background-color: ${item.teamColor};"
              />
              <span
                class="checkmark line flex-mid"
                style="background-color: ${item.teamColor};"
              >
                <div class="width-line"></div>
              </span>
              <span class="checkmark number flex-mid" style="background-color: ${
                item.teamColor
              };">
                ${item.directReport}
              </span>
              <div class="child-chart">
                <div class="flex-mid">
                  <div
                    class="opa-01"
                    style="
                      width: 2px;
                      height: 20px;
                      background-color: #000;
                    "
                  ></div>
                </div>
                <!-- <div v-html="orgChartConfig.HTML"></div> -->
                ${this.checkedChild(item)}
              </div>
            </div>
          </div>
        `;
      } else {
        orgCard = `
          <div class="org-container">
            <div class="tree-line">
              <div class="${threeLine}"></div>
            </div>
            <div class="flex-mid mx-auto" style="width: 252px;">
              <div
                class="opa-01"
                style="
                  width: 2px;
                  height: 14px;
                  background-color: #000;
                "
              ></div>
            </div>
            <div
              id="orgChart_${item.id}"
              class="org-card"
              style="border-left-color: ${item.teamColor};"
            >
              <div class="info-box flex-center ${blurClass}">
                ${picProfile}
                <div class="flex-column card-description">
                  <span class="fs-13 fw-700 ellipsis">${item.firstname} ${
          item.lastname
        }</span>
                  <span class="fs-13 opa-06 ellipsis">${item.teamName}</span>
                </div>
              </div>
              <div class="footer-box flex-center">
                <div class="div-active">
                  <div class="btn-status status-${item.status}">
                    ${item.status}
                  </div>
                </div>
                <div class="ml-auto fs-11 fw-700">${this.$t("insights.Impact_Rating")}</div>
                <div
                  class="ml-8 impact-tag impact-tag-${
                    item.impact_rating < 40
                      ? "red"
                      : item.impact_rating < 70
                      ? "yellow"
                      : "green"
                  }"
                >
                  ${item.impact_rating.toFixed(1)}
                </div>
              </div>
            </div>
          </div>
        `;
      }
      return { html: orgCard, leader: teamLeader };
    },
    clecrDataSerach() {
      const oldSearch = this.orgChartOldSearch;
      if (oldSearch.length > 0) {
        this.orgChartOldSearch = [];
        for (let i = 0; i < oldSearch.length; i++) {
          const elementFocus = document.getElementById(oldSearch[i]);
          elementFocus.classList.remove("card-focus");
        }
      }
      this.orgChartSearch = "";
    },
    orgCharClose() {
      this.clecrDataSerach();
      this.orgCharDialog = false;
    },
    // ignoreWarning() {
    //   const newValue = this.emptyMember.length;
    //   localStorage.setItem("_ignore_empty_team", newValue);
    //   this.ignoreBTN++
    // },
    // deleteEmptyTeam() {
    //   console.log("deleteEmptyTeam",this.emptyMember);
    //   this.$store.dispatch("newmember/deleteEmptyTeam",this.emptyMember).then(()=>{
    //   localStorage.setItem("_ignore_empty_team", 0);
    //   this.$message({
    //     type: 'success',
    //     message: 'Delete completed'
    //   });
    //   });
     
    // },
    // confirmEmptyTeam() {
    //   this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
    //       confirmButtonText: 'OK',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       this.deleteEmptyTeam();
    //     }).catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: 'Delete canceled'
    //       });          
    //     });
    // }
  },
};
</script>

<style lang="scss" scoped>
.divImgLogoPage {
  width: 32;
  height: 32;
}
.styleTab {
  margin-top: 32px;
  background: #ffffff;
}
.org-chart-btn {
  width: 52px;
  height: 52px;
  background-color: #ffffff;
  border: 1px solid #e2e4ea;
  border-radius: 8px;
  color: #4a4a4a;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.org-chart-btn:hover {
  background-color: #f6f7f9;
  border-color: #d4d7de;
  color: #6c30cc;
}
</style>
<style lang="scss">
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .value {
      text-overflow: ellipsis;
      overflow: hidden;
      padding-left: 16px;
      padding-right: 16px;
    }
    .link {
      font-size: 12px;
      color: #b4b4b4;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
}
.zoom-container {
  position: relative;
  > .box-container {
    position: absolute;
    top: 20px;
    left: 20px;
    .box {
      cursor: pointer;
      width: 40px;
      height: 20px;
      border: 1px solid #b4b4b4;
      box-shadow: 0px 0px 5px #00000029;
      margin: 0 5px 0 0;
    }
    .plus {
      border-radius: 4px 0 0 4px;
    }
    .minus {
      border-radius: 0 4px 4px 0;
    }
  }
}
.org-container {
  > .tree-line {
    .line {
      height: 2px;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        width: 100%;
        height: 2px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
    .line.first {
      &::after {
        right: 0;
        width: calc(50% + 1px);
      }
    }
    .line.last {
      &::after {
        width: calc(50% + 1px);
      }
    }
  }
  > .org-card {
    width: 220px;
    background-color: #fff;
    margin: 0 auto;
    border-radius: 4px;
    border: 0px solid #00000010;
    border-width: 0 0 0 4px;
    box-shadow: 0px 0px 6px #00000029;
    > .info-box {
      padding: 12px 8px;
      > .card-description {
        width: 115px;
      }
    }
    > .footer-box {
      display: grid;
      grid-template-columns: 54px minmax(78px, 1fr) 42px;
      column-gap: 7px;
      align-items: center;
      padding: 6px 10px 6px 8px;
      background-color: rgba(0, 0, 0, 0.05);

      > .div-active {
        min-width: 0;
        justify-self: start;
      }

      > .div-active > .btn-status {
        min-width: 54px;
        width: 54px;
        padding: 0 6px;
      }

      > .ml-auto {
        justify-self: end;
        margin-left: 0 !important;
        white-space: nowrap;
        min-width: 0;
        line-height: 1;
        text-align: right;
      }

      > .impact-tag {
        width: 42px;
        justify-self: end;
        margin-left: 0 !important;
        padding: 4px 0;
      }
    }
  }
  > .org-card.card-focus {
    background-color: #e8e8e8;
    box-shadow: 0px 0px 6px #00000049;
  }
  > .org-card.border-for-export {
    border-width: 1px 1px 1px 4px;
  }
  > .child-chart-container {
    position: relative;
    margin: auto;
    width: 100%;
    > .checkmark {
      height: 23px;
      width: 23px;
      top: -44px;
      border-radius: 2px;
    }
    .checkmark.checkbox,
    .checkmark.line,
    .checkmark.number {
      background-color: #c4c4c4;
      position: absolute;
      left: calc(50% + 76px);
      top: -78px;
      cursor: pointer;
      color: #fff;
    }
    > .checkbox {
      opacity: 0;
      z-index: 99;
    }
    > .checkmark.number {
      font-size: 11px;
      opacity: 1;
    }
    > .checkmark.line {
      line-height: 24px;
      font-size: 40px;
      opacity: 0;
      > .width-line {
        width: 12px;
        height: 0;
        border: 2px solid #fff;
        border-width: 2px 0 0 0;
      }
    }
    > .child-chart {
      display: none;
    }
    > input[type="checkbox"] {
      width: 23px;
      height: 23px;
      margin: 0;
      &:checked ~ .checkmark.line {
        opacity: 1;
      }
      &:checked ~ .checkmark.number {
        opacity: 0;
      }
      &:checked ~ .child-chart {
        display: block;
      }
    }
  }
}
#membersContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#membersContainer .el-tabs__header {
  margin: 0px;
}

#reAssignManagerModal .el-dialog {
  width: 1100px;
}
#managerWarmingModal .el-dialog__header,
#reAssignManagerModal .el-dialog__header {
  padding: 0px;
}
#reAssignManagerModal .el-dialog__body {
  padding: 0px;
  height: 847px;
}
.org-chart-height {
  height: calc(100vh - ((5vh + 5vh) + 150px));
}
</style>
